import { Smartphone } from 'lucide-react';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';
import { t } from '../i18n';

/**
 * Signing in on the phone app: the app asks for this site's address, or
 * scans it from here. The code holds only the address, nothing secret.
 */
export function PhoneAppCard() {
  const address = `https://${window.location.host}`;
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    // Drawn here, in the browser: the address isn't sent anywhere to make it.
    void QRCode.toString(address, { type: 'svg', margin: 1, errorCorrectionLevel: 'M', color: { dark: '#0f1726', light: '#ffffff' } }).then(setSvg);
  }, [address]);

  return (
    <div className="card">
      <div className="card-header">
        <div className="row" style={{ gap: '0.6rem' }}>
          <Smartphone size={18} className="subtle" aria-hidden />
          <h2>{t('Phone app')}</h2>
        </div>
      </div>
      <div className="card-body phone-app">
        {svg && <div className="qr" role="img" aria-label={t('Code for {address}', { address })} dangerouslySetInnerHTML={{ __html: svg }} data-testid="app-qr" />}
        <div className="stack" style={{ gap: '0.4rem' }}>
          <p>{t('Make and take calls on your phone too. Install the app, then scan this code, or enter the address:')}</p>
          <p className="tabular" style={{ fontWeight: 600 }}>
            {window.location.host}
          </p>
          <p className="subtle" style={{ fontSize: '0.85rem' }}>
            {t('Then sign in with the same email and password as here.')}
          </p>
        </div>
      </div>
    </div>
  );
}
